import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { VmeCommonModule } from '../../../vme-common.module';
import { SelectItem, SelectItemGroup } from 'primeng';
import { AdditionalChargeService, BBWTMessageService } from 'src/app/services';
import { IExpenseAssigneeOption } from '../../../interfaces/additional-charge';

@Component({
  selector: 'change-assignee',
  styleUrls: ['../../job-screen/common/common-scss/job-screen-additional-costs-common.scss'],
  templateUrl: './change-assignee.component.html',
  standalone: true,
  imports: [VmeCommonModule],
})
export class ChangeAssigneeComponent implements OnInit {
  constructor(
    private additionalChargeService: AdditionalChargeService,
    private messageService: BBWTMessageService,
  ) {}
  @Input() jobId: number;
  @Input() visible = false;
  @Input() selectedAssignee: string = '';
  @Input() assigneeAdditionalChargeId: number;
  @Input() hideAssignAllCheckbox: boolean = false;
  @Output() visibleChange: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() assigneeChanged = new EventEmitter<void>();
  private _assignee: string;
  public assigneeOptions: SelectItemGroup[] = [];
  public assignees: IExpenseAssigneeOption[] = [];
  public assignOtherPendingExpenses: boolean = true;
  public saving: boolean = false;
  public assigneesLoading: boolean = false;
  public currentUserId: string = null;
  public showAssignAllExpenses: boolean = true;

  public get assignee(): string {
    return this._assignee;
  }

  public set assignee(value: string) {
    this._assignee = value;
    this.setShowAssignAllExpenses(value);
  }

  public async ngOnInit() {
    void this.getAssignees();
  }

  private async getAssignees() {
    if (this.assignees.length == 0 || this.currentUserId == null) {
      this.assigneesLoading = true;
      const result = await this.additionalChargeService.getExpenseAssigneeOptions();
      this.assignees = result.options;
      this.currentUserId = result.currentUserId;
      this.assigneesLoading = false;
    }

    const adminTeamAssignees = this.assignees
      .filter((x) => x.isAdminTeam)
      .sort((a, b) => a.name.trim().localeCompare(b.name.trim()))
      .map((x) => <SelectItem>{ value: x.id, label: x.name });

    const otherTeamAssignees = this.assignees
      .filter((x) => !x.isAdminTeam)
      .sort((a, b) => a.name.trim().localeCompare(b.name.trim()))
      .map((x) => <SelectItem>{ value: x.id, label: x.name });

    adminTeamAssignees.unshift({ value: null, label: 'None' });

    this.assigneeOptions = [
      {
        label: 'Admin Team',
        items: adminTeamAssignees,
      },
      {
        label: 'Other',
        items: otherTeamAssignees,
      },
    ];

    // this.assigneeOptions = this.assignees
    //   .sort((a, b) => a.name.trim().localeCompare(b.name.trim()))
    //   .map((x) => <SelectItem>{ value: x.id, label: x.name });
    //
    // this.assigneeOptions.unshift({ value: null, label: 'None' });

    if (this.selectedAssignee) {
      this.assignee = this.selectedAssignee;
      return;
    }

    const currentUserOption = this.assigneeOptions.find((x) => x.value == this.currentUserId);

    if (!currentUserOption) {
      this.assignee = this.assigneeOptions[0].value;
      return;
    }

    this.assignee = currentUserOption.value;
  }

  async saveChangeAssignee() {
    try {
      this.saving = true;
      await this.additionalChargeService.changeAssignee(
        this.assigneeAdditionalChargeId,
        this.assignee,
        this.jobId,
        this.assignOtherPendingExpenses,
      );
      this.messageService.ShowSuccess('Success', 'Assignee changed successfully');
      this.assigneeChanged.emit();

      this.visibleChange.emit(false);
    } catch (error) {
      this.messageService.ShowError('Error', 'Error changing assignee');
      console.log(error);
    } finally {
      this.saving = false;
    }
  }

  closeAssigneeDialog() {
    this.visibleChange.emit(false);
  }

  getApplyToAllCheckboxText() {
    if (this.assigneesLoading) {
      return '';
    }

    if (this.assignee) {
      const assigneeName = this.assignees.find((x) => x.id == this.assignee)?.name;
      return `Assign ${assigneeName} to all pending expenses`;
    }

    return 'Remove assignee from all pending expenses';
  }

  getAutoApplyToAllText() {
    if (this.assigneesLoading) {
      return '';
    }

    if (this.assignee) {
      const assigneeName = this.assignees.find((x) => x.id == this.assignee)?.name;
      return `Assign ${assigneeName} to all pending expenses within the selected job`;
    }

    return 'Remove assignee from all pending expenses within the selected job';
  }

  private setShowAssignAllExpenses(selectedAssignee: string) {
    if (this.hideAssignAllCheckbox) {
      this.showAssignAllExpenses = false;
      return;
    }

    const assignee = this.assignees.find((x) => x.id == selectedAssignee);

    this.showAssignAllExpenses = assignee?.isAdminTeam ?? true;
  }
}
